<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('schedule.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('schedule.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'schedule-create' })"
              >{{ $t('add_new') }}</ts-button
            >
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('Search')"
              style="width: 300px"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('invoice.filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'academic_program_sub.acps_name_foreign'
        }"
      >
        <template v-slot="{ record }">
          <td>
            {{
              record.academic_class != null
                ? record.academic_class.branch != null
                  ? record.academic_class.branch.branch_name_en
                  : ''
                : ''
            }}
          </td>
          <td>
            {{
              record.academic_class != null
                ? record.academic_class.class_name
                : ''
            }}
          </td>
          <td>
            {{
              record.weekday_from != null ? record.weekday_from.wd_name_en : ''
            }}
          </td>
          <td>
            {{ record.weekday_to != null ? record.weekday_to.wd_name_en : '' }}
          </td>
          <td>
            {{
              record.schedule_type != null
                ? record.schedule_type.sch_type_name
                : ''
            }}
          </td>
          <td>
            {{
              record.academic_year != null ? record.academic_year.ac_year : ''
            }}
          </td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="$t('schedule.classSchedule')"
              class="text-primary"
              @click.prevent="schedule(record)"
            >
              <i class="fas fa-calendar-alt"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- drawer -->
      <a-drawer
        :title="$t('invoice.filter')"
        placement="right"
        :closable="false"
        :visible="visible"
        @close="() => (visible = false)"
        :zIndex="1020"
        width="300px"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <a-select
                style="width: 257px"
                v-model="branch_id"
                :options="branchs"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
              >
              </a-select>
            </div>
          </div>
        </div>
      </a-drawer>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'schedule-table',
  data () {
    return {
      branchs: [],
      branch_id: null,
      loading: false,
      visible: false
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('schedule', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.schedule.search
      },
      set (newValue) {
        this.$store.commit('schedule/SET_SEARCH', newValue)
        this.$store.commit('schedule/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          name: this.$t('schedule.branch'),
          sortKey: 'academic_class.branch.branch_name_en',
          style: 'width: 10%'
        },
        {
          name: this.$t('schedule.className'),
          sortKey: 'academic_class.class_name'
        },
        {
          name: this.$t('schedule.dayFrom'),
          sortKey: 'academic_class.class_name'
        },
        { name: this.$t('schedule.dayTo'), sortKey: 'weekday_from.wd_name_en' },
        { name: this.$t('schedule.type'), sortKey: 'weekday_to.wd_name_en' },
        { name: this.$t('schedule.academicYear') },
        { name: this.$t('actions'), style: 'width: 1%; text-align: center' }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'schedule/fetch',
          Object.assign({}, { branch_id: this.branch_id }, attributes)
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit (record) {
      this.$store.commit('schedule/SET_FOUND_DATA', record)
      this.$router.push({
        name: 'schedule-edit',
        params: { id: record.sch_id }
      })
    },
    schedule (record) {
      this.$store.commit('schedule/SET_FOUND_DATA', record)
      this.$router.push({
        name: 'schedule-show',
        params: { id: record.sch_id }
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'schedule-create') {
      this.$store.commit('schedule/RESET_STATE')
      this.$store.commit('schedule/RECEIVE_ACADEMIC_YEARS', [])
      this.$store.commit('schedule/RECEIVE_ACADEMIC_PROGRAM_MAINS', [])
      this.$store.commit('schedule/RECEIVE_ACADEMIC_PROGRAM_SUBS', [])
      this.$store.commit('schedule/RECEIVE_CLASSES', [])
      this.$store.commit('schedule/SET_WEEKDAYS', [])
      this.$store.commit('schedule/SET_SCHEDULE_TYPES', [])
    }
    next()
  }
}
</script>
